import { useRef } from 'react';
import { IRefinementList } from '@monofront/types';
import { dataLayerTrackEvent } from '@utils/tracking';
import { trackEvent } from '@monofront/tracking';
import { IndexUiState } from 'instantsearch.js';

/**
 * Analytics tracking for search filters.
 * @returns A callback to call when search has changed.
 */
const useTrackFilter = () => {
  const appliedSearchState = useRef<IRefinementList>({});

  return function (nextSearchState: IndexUiState) {
    if (nextSearchState.refinementList) {
      for (const filterType of Object.keys(nextSearchState.refinementList)) {
        if (Array.isArray(nextSearchState.refinementList![filterType])) {
          if (
            !appliedSearchState.current[filterType] ||
            appliedSearchState.current[filterType] === '' ||
            nextSearchState.refinementList![filterType].length >
              appliedSearchState.current[filterType].length
          ) {
            // deprecated tracker https://gitlab.com/la-fourche/scrum/-/issues/1968
            dataLayerTrackEvent('filterApplied', { filterType });

            trackEvent({
              type: 'LFApplyFilter',
              data: {
                type: filterType,
                selected: nextSearchState.refinementList![filterType],
              },
            });

            break;
          }
        }
      }

      appliedSearchState.current = { ...nextSearchState.refinementList! };
    }
  };
};

export default useTrackFilter;
